import { render, staticRenderFns } from "./CoreBarProfile.vue?vue&type=template&id=328aef0c&scoped=true"
import script from "./CoreBarProfile.vue?vue&type=script&lang=js"
export * from "./CoreBarProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328aef0c",
  null
  
)

export default component.exports